import { IStore } from 'store/types';
import { IApiList, ILedgerEntry } from 'types';

export const selectLedgerEntries =
  () =>
  (state: IStore): IApiList<ILedgerEntry> =>
    state?.collections?.ledger;
